import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';
import { planFeatures } from './plans';

const PlanDetailsModal = ({
  visible,
  selectedPlan,
  onConfirm,
  onCancel,
}) => {
  if (!selectedPlan) {
    return null;
  }

  const planName = selectedPlan.name;
  const features = planFeatures[planName] || [];

  return (
    <Modal
      width={700}
      title={`${planName} Plan Features`}
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Back
        </Button>,
        <Button
          key="confirm"
          type="primary"
          onClick={onConfirm}
        >
          Continue to Payment
        </Button>,
      ]}
    >
      <div>
        <h3>What&apos;s included in the {planName} plan:</h3>
        {features.length > 0 ? (
          <ul style={{ paddingLeft: '20px', lineHeight: '1.8' }}>
            {features.map((feature, index) => (
              <li key={`feature-${planName}-${index}`} style={{ marginBottom: '8px' }}>
                {feature}
              </li>
            ))}
          </ul>
        ) : (
          <p>No features included in this plan.</p>
        )}
      </div>
    </Modal>
  );
};

PlanDetailsModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  selectedPlan: PropTypes.shape({
    name: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    userTypeName: PropTypes.string.isRequired,
    previousPlan: PropTypes.string,
  }),
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

PlanDetailsModal.defaultProps = {
  selectedPlan: null,
};

export default PlanDetailsModal;




// WEBPACK FOOTER //
// ./src/components/Billsby/PlanDetailsModal.jsx